import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('GENERATE VOUCHER', [
    'CONTENT_TOP',
    'PRODUCTS_SECTION',
    'PAYMENTS_SECTION',
    'CREDIT_PAYMENTS',
    'TABLE_PAYMENTS'
])
